export var SalesOrderItemStatus;
(function (SalesOrderItemStatus) {
    SalesOrderItemStatus[SalesOrderItemStatus["ENTERED"] = 1] = "ENTERED";
    SalesOrderItemStatus[SalesOrderItemStatus["PICKING"] = 2] = "PICKING";
    SalesOrderItemStatus[SalesOrderItemStatus["PARTIAL"] = 3] = "PARTIAL";
    SalesOrderItemStatus[SalesOrderItemStatus["FULFILLED"] = 4] = "FULFILLED";
    SalesOrderItemStatus[SalesOrderItemStatus["SHORT"] = 5] = "SHORT";
    SalesOrderItemStatus[SalesOrderItemStatus["VOID"] = 6] = "VOID";
})(SalesOrderItemStatus || (SalesOrderItemStatus = {}));
//# sourceMappingURL=sales-order-item-status.js.map